module.exports = __webpack_public_path__ + "img/day1.ccb627ad.svg";